export type Answer = {
  questionId: string;
  value: number | string | null;
  transcript: string | null;
  updatedAt: number;
  // correction UX の Move On: 訂正試行が閾値を超えて AI が「後で見直せます」と提案 → user が
  // 「進む」を選択した Q に立つ。Review 画面で warning badge を出す判定に使う。
  skipped?: boolean;
};

const KEY_PREFIX = "audio-form:answers:";

export function saveToStorage(surveyId: string, answers: Record<string, Answer>): void {
  try {
    localStorage.setItem(KEY_PREFIX + surveyId, JSON.stringify(answers));
  } catch {
    // QuotaExceeded / SecurityError 等は静かに無視（PoC）
  }
}

export function loadFromStorage(surveyId: string): Record<string, Answer> | null {
  const raw = localStorage.getItem(KEY_PREFIX + surveyId);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Record<string, Answer>;
  } catch {
    return null;
  }
}

export function clearStorage(surveyId: string): void {
  localStorage.removeItem(KEY_PREFIX + surveyId);
}
